export default __webpack_public_path__ + "static/media/ico_hood_offline.1f0b5929.svg";